export const HOURS_IN_24_FORMAT_DAY = 24;
export const HOURS_IN_12_FORMAT_DAY = 12;
export const HOURS_IN_DAY = 24;
export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_MINUTE = 60;
export const WEEK_LENGTH = 7;
